const Stethoscope = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M34.5 23H28.75C25.7 23 22.7749 24.2116 20.6183 26.3683C18.4616 28.5249 17.25 31.45 17.25 34.5V54.625C17.25 63.0125 20.5819 71.0564 26.5127 76.9873C32.4436 82.9181 40.4875 86.25 48.875 86.25C57.2625 86.25 65.3064 82.9181 71.2373 76.9873C77.1681 71.0564 80.5 63.0125 80.5 54.625V34.5C80.5 31.45 79.2884 28.5249 77.1317 26.3683C74.9751 24.2116 72.05 23 69 23H63.25M46 86.25C46 90.7806 46.8924 95.2668 48.6262 99.4526C50.3599 103.638 52.9012 107.442 56.1048 110.645C59.3084 113.849 63.1117 116.39 67.2974 118.124C71.4832 119.858 75.9694 120.75 80.5 120.75C85.0306 120.75 89.5168 119.858 93.7026 118.124C97.8883 116.39 101.692 113.849 104.895 110.645C108.099 107.442 110.64 103.638 112.374 99.4526C114.108 95.2668 115 90.7806 115 86.25V69M115 69C111.95 69 109.025 67.7884 106.868 65.6317C104.712 63.4751 103.5 60.55 103.5 57.5C103.5 54.45 104.712 51.5249 106.868 49.3683C109.025 47.2116 111.95 46 115 46C118.05 46 120.975 47.2116 123.132 49.3683C125.288 51.5249 126.5 54.45 126.5 57.5C126.5 60.55 125.288 63.4751 123.132 65.6317C120.975 67.7884 118.05 69 115 69ZM63.25 17.25V28.75M34.5 17.25V28.75"
            stroke="#F4C4B5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Stethoscope;
